import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$orgPid/pricing-calendar')({
  component: PricingCalendarPage,
});

function PricingCalendarPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Pricing Calendar</h1>
        <p className="text-muted-foreground">View and manage seasonal pricing across your fleet</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Calendar View</CardTitle>
          <CardDescription>
            Set weekly charter prices by season, vessel, and period.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">
            Add vessels to your fleet to start managing pricing.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
